import type { Kid } from '../generated-types';

// eslint-disable-next-line import/prefer-default-export
export const formatKid = (kid: Kid | undefined, seperator = ' '): string => {
    return kid?.value.match(/.{1,4}/g)?.join(seperator) ?? '';
};
